<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>{{serviceId ? "Update Service Record": "Add New Service Record"}}{{serviceData?.refNo ? " - " + serviceData?.refNo : ''}}</h2>
</div>
<!--form section-->
<section>
  <nz-card>

    <div>
      <h5 class="text-primary my-3">Service Information</h5>
      <div class="grid xl:grid-cols-2 gap-4 items-center">
        <form nz-form [formGroup]="serviceForm" [nzLayout]="'vertical'">
          <div>
            <div class="grid sm:grid-cols-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="serviceType" nzRequired>Service Type</nz-form-label>
                <nz-form-control [nzErrorTip]="serviceTypeError">
                  <nz-select (ngModelChange)="serviceTypeCheck($event)" formControlName="serviceType"
                             nzPlaceHolder="Select Service Type">
                    <nz-option nzValue="NORMALSERVICE" nzLabel="Normal service"></nz-option>
                    <nz-option nzValue="TRANSMISSION" nzLabel="Transmission oil change"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #serviceTypeError>
                  <span *ngIf="formErrors.serviceType.required">Please select type. </span>
                </ng-template>
              </nz-form-item>
            </div>
            <div class="grid sm:grid-cols-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="currentMileage" nzRequired>Current Mileage</nz-form-label>
                <nz-form-control [nzErrorTip]="currentMileageError">
                  <nz-input-group nzAddOnAfter="Km">
                    <input nz-input type="number" [min]="0" [step]="1"  formControlName="currentMileage"
                           placeholder="Enter Current Mileage"/>
                  </nz-input-group>
<!--                  <nz-input-number-->
<!--                    class="w-full"-->
<!--                    formControlName="currentMileage"-->
<!--                    nzPlaceHolder="Enter Current Mileage"-->
<!--                    [nzMin]="0"-->
<!--                    [nzStep]="1"-->
<!--                    [nzFormatter]="formatterDistance"-->
<!--                    [nzParser]="parserDistance"-->
<!--                  ></nz-input-number>-->
                </nz-form-control>
                <ng-template #currentMileageError>
                  <span *ngIf="formErrors.currentMileage.required">Please enter mileage. </span>
                  <span *ngIf="formErrors.currentMileage.maxlength">Maximum 15 letters only. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
        </form>
        <div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>

            <div *ngIf="serviceTypeVal === 'NORMALSERVICE'">
              <tr>
                <td class="pr-5">Service will be done by</td>
                <td>{{serviceTypeLabelVal(fleetData?.vehicleInventory?.serviceResponsible)}}</td>
              </tr>
              <tr>
                <td class="pr-5">Service Oil change will be done by</td>
                <td>{{serviceTypeLabelVal(fleetData?.vehicleInventory?.serviceOilChangeResponsible)}}</td>
              </tr>
              <tr>
                <td class="pr-5">Last Service Date</td>
                <td>{{fleetData?.vehicleInventory?.latestServiceDate ? (fleetData?.vehicleInventory?.latestServiceDate | date: "dd-MM-y") : "-"}}</td>
              </tr>
              <tr>
                <td class="pr-5">Last Service Mileage</td>
                <td>{{fleetData?.vehicleInventory?.latestServiceMileage ? fleetData?.vehicleInventory?.latestServiceMileage + 'km' : '-'}}</td>
              </tr>
              <tr>
                <td class="pr-5">Next Service Mileage</td>
                <td>{{fleetData?.vehicleInventory?.nextServiceMileage ? fleetData?.vehicleInventory?.nextServiceMileage + 'km' : '-'}}</td>
              </tr>
            </div>
            <div *ngIf="serviceTypeVal === 'TRANSMISSION'">
              <tr>
                <td class="pr-5">Transmission oil Will be Done by</td>
                <td>{{serviceTypeLabelVal(fleetData?.vehicleInventory?.oilChangeResponsible)}}</td>
              </tr>
              <tr>
                <td class="pr-5">Last Transmission oil Date</td>
                <td>{{fleetData?.vehicleInventory?.latestOilChangeDate ? (fleetData?.vehicleInventory?.latestOilChangeDate | date: "dd-MM-y") : "-"}}</td>
              </tr>
              <tr>
                <td class="pr-5">Last Transmission oil Mileage</td>
                <td>{{fleetData?.vehicleInventory?.latestOilChangedMileage ? fleetData?.vehicleInventory?.latestOilChangedMileage + 'km' : '-'}}</td>
              </tr>
              <tr>
                <td class="pr-5">Next Transmission oil Mileage</td>
                <td>{{fleetData?.vehicleInventory?.nextOilChangedMileage ? fleetData?.vehicleInventory?.nextOilChangedMileage + 'km' : '-'}}</td>
              </tr>
            </div>


          </div>
        </div>
      </div>

      <div class="grid xl:grid-cols-2 gap-4">
        <div>
          <form nz-form [formGroup]="serviceForm" [nzLayout]="'vertical'">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="remark">Remarks</nz-form-label>
              <nz-form-control [nzErrorTip]="remarkError">
              <textarea nz-input formControlName="remark" placeholder="Enter Remarks"
                        [nzAutosize]="{ minRows: 7, maxRows: 7 }"></textarea>
              </nz-form-control>
              <ng-template #remarkError>
                <span *ngIf="formErrors.remark.maxlength">Maximum 150 letters only. </span>
              </ng-template>
            </nz-form-item>
          </form>
        </div>
        <div>
          <div class="pb-[8px]">Attachments</div>
          <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-48 py-2">
            <div>
              <nz-upload
                [nzCustomRequest]="vehicleBookUpload" [nzShowUploadList]="false" [nzMultiple]="true">
                <button nz-button>
                  <span nz-icon nzType="upload"></span>
                  Click to Upload
                </button>
              </nz-upload>
            </div>
            <div>
              <p *ngIf="imageUploading" class="text-primary my-2">Uploading...</p>
            </div>
            <div class="mt-2 overflow-auto">
              <div *ngFor="let file of vehicleBookUploadFiles; let i = index"
                   class="flex justify-between items-center mx-3 gap-5">
                <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                      class="cursor-pointer" nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this attachment"
                      (nzOnConfirm)="removeUploadFile(i)"
                ></span>
              </div>
            </div>
          </div>
        </div>


<!--        <div>-->
<!--          <p class="pb-[8px]">Copy of Vehicle Book</p>-->
<!--          <nz-upload [nzCustomRequest]="vehicleBookUpload" [nzShowUploadList]="false" [nzMultiple]="false"-->
<!--                     class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
<!--            <button nz-button>-->
<!--              <span nz-icon nzType="upload"></span>-->
<!--              Click to Upload-->
<!--            </button>-->
<!--          </nz-upload>-->
<!--          <div *ngFor="let file of vehicleBookUploadFiles">-->
<!--            <a target="_blank" href="{{file.url}}">{{file.name}}</a>-->
<!--          </div>-->
<!--        </div>-->
      </div>

    </div>
    <div>
      <h5 class="text-primary my-3">Actions List</h5>
      <nz-alert class="sm:hidden mb-2" nzType="info" nzMessage="Scroll horizontally to see more..."></nz-alert>
      <div class="grid xl:grid-cols-3">

          <div class="xl:col-span-2 whitespace-nowrap overflow-x-auto">
            <form nz-form [formGroup]="actionListForm" class="mb-5">
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Change Check</td>
                <div>
                  <span nz-checkbox formControlName="isOilChange">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Filter Change Check</td>
                <div>
                  <span nz-checkbox formControlName="isOilFilterChange">Done</span>
                </div>
              </tr>
              <tr *ngIf="serviceTypeVal === 'TRANSMISSION'" class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Transmission Oil Check</td>
                <div>
                  <span nz-checkbox formControlName="isTransIolCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Coolant Check</td>
                <div>
                  <span nz-checkbox formControlName="isCoolantCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Oil Check</td>
                <div>
                  <span nz-checkbox formControlName="isBreakOilCheck">Done</span>
                  <span nz-checkbox formControlName="isNextBreakOilCheck">Change/check next service</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Air Filter Check</td>
                <div>
                  <span nz-checkbox formControlName="isAirFilterCheck">Done</span>
                  <span nz-checkbox formControlName="isNextAirFilterCheck">Change/check next service</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Battery Check</td>
                <div>
                  <span nz-checkbox formControlName="isBatteryCheck">Done</span>
                  <span nz-checkbox formControlName="isNextBatteryCheck">Change/check next service</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Cabin Filter Check</td>
                <div>
                  <span nz-checkbox formControlName="isCabinFilterCheck">Done</span>
                </div>
              </tr>

            <tr class="my-2"></tr>

              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Pads Check</td>
                <div>
                  <span nz-checkbox formControlName="isBreakPadCheck">Done</span>
                  <span nz-checkbox formControlName="isNextBreakPadCheck">Change/check next service</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Tyre Check</td>
                <div>
                  <span nz-checkbox formControlName="isTypeCheck">Done</span>
                  <span nz-checkbox formControlName="isNextTypeCheck">Change/check next service</span>
                </div>
              </tr>

              <tr class="flex my-2"></tr>

              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Under Carriage Check</td>
                <div>
                  <span nz-checkbox formControlName="isUnderCarriageCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Boot Check</td>
                <div>
                  <span nz-checkbox formControlName="isBootCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Leak Check</td>
                <div>
                  <span nz-checkbox formControlName="isOilLeakCheck">Done</span>
                </div>
              </tr>

              <tr class="flex my-2"></tr>

              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Wiper Check</td>
                <div>
                  <span nz-checkbox formControlName="isWiperCheck">Done</span>
                  <span nz-checkbox formControlName="isNextWiperCheck">Change/check next service</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Horn Check</td>
                <div>
                  <span nz-checkbox formControlName="isHornCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Interior Check</td>
                <div>
                  <span nz-checkbox formControlName="isInteriorCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">A/C Check</td>
                <div>
                  <span nz-checkbox formControlName="isACCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Bluetooth Connection Check</td>
                <div>
                  <span nz-checkbox formControlName="isBluetoothCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Interior Light Check</td>
                <div>
                  <span nz-checkbox formControlName="isInteriorLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Power Mirror Check</td>
                <div>
                  <span nz-checkbox formControlName="isPowerMirrorCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Power Shutter Check</td>
                <div>
                  <span nz-checkbox formControlName="isPowerShutterCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Hand Break Check</td>
                <div>
                  <span nz-checkbox formControlName="isHandBreakCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Spare Wheel Check</td>
                <div>
                  <span nz-checkbox formControlName="isSpareWheelCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Toolkit Check</td>
                <div>
                  <span nz-checkbox formControlName="isSpareWheelCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Glue Bottle Check</td>
                <div>
                  <span nz-checkbox formControlName="isGlueBottleCheck">Done</span>
                </div>
              </tr>

              <tr class="flex my-2"></tr>

              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Front Head Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isFrontHeadLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Front Signal Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isFrontSignalLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Fog Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isFogLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Winker Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isWinkerLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Rear Signal Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isRearSignalLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isBreakLightCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Revers Lights Check</td>
                <div>
                  <span nz-checkbox formControlName="isReversLightCheck">Done</span>
                </div>
              </tr>

              <tr class="flex my-2"></tr>

              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Carpet Wash Check</td>
                <div>
                  <span nz-checkbox formControlName="isCarpetWashCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Full Body Wash Check</td>
                <div>
                  <span nz-checkbox formControlName="isFullBodyWashCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Under Carriage Wash Check</td>
                <div>
                  <span nz-checkbox formControlName="isUnderCarriageWashCheck">Done</span>
                </div>
              </tr>
              <tr class="grid grid-cols-12">
                <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Engine De-greasing Check</td>
                <div>
                  <span nz-checkbox formControlName="isEngineGreasingCheck">Done</span>
                </div>
              </tr>

            </form>
          </div>

      </div>
    </div>
    <div class="flex flex-col-reverse min-[450px]:flex-row justify-end gap-3 my-3">
      <button class="outline-button" nz-button nzType="default" nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
              [nzOkText]="'Yes'" [nzCancelText]="'No'"
              (nzOnConfirm)="cancel()">Cancel</button>
      <button nz-button nzType="primary" nz-popconfirm
              nzPopconfirmTitle="You cannot edit the details after saving the record. Are you sure you want to save the record?"
              [nzOkText]="'Yes'" [nzCancelText]="'No'" [disabled]="serviceForm.invalid" (nzOnConfirm)="submit()">{{serviceId ? "Update Service Record": "Add New Service Record"}}</button>
    </div>
  </nz-card>
</section>
